module.exports = __webpack_public_path__ + "static/media/SelfCompassionAndAcceptance.34fcb101.mp3";